<template>
  <div id="book-show">
    <disabled-overlay/>
    <profile-module/>
    <b-col>
      <h1 class="title">{{ $t('pages.book.title') }}</h1>
      <p class="intro">{{ $t('pages.book.intro') }}</p>
    </b-col>
    <e-index
      :uri="$helper.getUri('book')"
      :modal-uri-create="`api/public/memorial/${id}/book`"
      :modal-uri="`api/memorial/${id}/book`"
      :order-call-back="orderCallBack"
      :can-manage="$root.canManage()"
      :can-create="!$root.isDemo() || $root.canManage()"
      name="book"
    >
      <div slot="list-content" slot-scope="ctx">
        <span
          class="red-text step-title">{{ ctx.item.updated_at | moment('LL') }}</span>
        <div class="clearfix" />
        <span v-html="$helper.demoFallbackTranslation(ctx.item, 'text')" />
        <contact-entity :contact="ctx.item.contact" />
      </div>
    </e-index>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import ProfileModule from '@/components/ProfileModule';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import ContactEntity from '@/components/ContactEntity';
  import MemorialGuard from '@/mixins/MemorialGuard';

  export default {
    name: 'BookIndex',
    components: {
      EIndex,
      ProfileModule,
      DisabledOverlay,
      ContactEntity,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    methods: {
      orderCallBack(collection) {
        return _.orderBy(collection, ['created_at'], ['desc']);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  #book-show {
    /deep/ .list-group {
      .list-group-item {
        p {
          color: $black;
        }
      }
    }

    /deep/ .modal-form {
      overflow: auto;
    }
  }

  @include editable-max-width(600px) {
    #book-show {
      /deep/ .modal-form {
        .sweet-modal {
          top: $nav-height;
          height: auto;
          max-height: none;
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Book/index.vue